import React from "react";

export function KPICard({ label, value, hint, accent = false, testId }) {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl p-6 border transition-all hover:-translate-y-0.5 ${
        accent
          ? "border-indigo-400/30 bg-gradient-to-br from-indigo-500/15 via-purple-500/8 to-transparent shadow-[0_18px_40px_-18px_rgba(79,70,229,0.55)]"
          : "border-white/[0.08] bg-white/[0.025] backdrop-blur-xl shadow-[0_12px_30px_-15px_rgba(0,0,0,0.6)]"
      }`}
      data-testid={testId}
    >
      <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 font-semibold mb-2">
        {label}
      </div>
      <div
        className={`font-mono-data text-3xl font-medium tracking-tight ${
          accent ? "text-indigo-200" : "text-white"
        }`}
      >
        {value}
      </div>
      {hint && <div className="text-xs text-slate-500 mt-2">{hint}</div>}
      {accent && (
        <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-indigo-400 to-purple-500" />
      )}
    </div>
  );
}

export default KPICard;
